'use strict';

module.exports = row;

var all = require('../all');

function row(h, node) {
  return h(node, 'tableRow', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/table-row.js
// module id = 1020
// module chunks = 0